import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ClientProfile } from '@syfo/types/api.client.types';
import { checkAuthThunk } from './thunks/check-auth-thunk';

export interface AuthState {
  isAuthenticated: boolean | null; // null = loading, false = not authenticated, true = authenticated
  userProfile: ClientProfile | null;
}

const initialState: AuthState = {
  isAuthenticated: null,
  userProfile: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    setUserProfile: (state, action: PayloadAction<ClientProfile | null>) => {
      state.userProfile = action.payload;
      state.isAuthenticated = action.payload !== null;
    },
    clearAuth: (state) => {
      state.isAuthenticated = false;
      state.userProfile = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkAuthThunk.pending, (state) => {
        state.isAuthenticated = null;
      })
      .addCase(checkAuthThunk.fulfilled, (state, action) => {
        state.userProfile = action.payload;
        state.isAuthenticated = action.payload !== null;
      })
      .addCase(checkAuthThunk.rejected, (state) => {
        state.isAuthenticated = false;
        state.userProfile = null;
      });
  },
});

export const { setAuthenticated, setUserProfile, clearAuth } = authSlice.actions;
export default authSlice.reducer;
